/** Legacy summaries have no restriction fields. New summaries must describe all three together. */
export function displayFamilyName(key) {
  return key.replaceAll('_', ' ').replace(/\b[a-z]/g, (letter) => letter.toUpperCase());
}

export function validBankFamilies(families) {
  return (
    Array.isArray(families) &&
    families.every((family) => {
      if (
        !family ||
        (family.productAccessAllowed !== undefined &&
          typeof family.productAccessAllowed !== 'boolean') ||
        !/^[a-z][a-z0-9_]{1,39}$/.test(family.key) ||
        !Number.isSafeInteger(family.balance) ||
        family.balance < 0
      )
        return false;
      const fields = ['spendableUnits', 'spendingBlocked', 'restrictionRevision'];
      if (fields.every((key) => family[key] === undefined))
        return family.productAccessAllowed === undefined;
      return (
        typeof family.spendingBlocked === 'boolean' &&
        Number.isSafeInteger(family.restrictionRevision) &&
        family.restrictionRevision >= 0 &&
        Number.isSafeInteger(family.spendableUnits) &&
        family.spendableUnits ===
          (family.spendingBlocked || family.productAccessAllowed === false ? 0 : family.balance)
      );
    })
  );
}
